import React, { FC } from 'react';

//components
import AampeTooltip from '../../../components/shared/AampeTooltip/AampeTooltip';
import styled from 'styled-components';

//constants
import ICONS from '../../../constants/icons';

interface WarningIconComponentProps {
    type: string;
}

const WarningIconComponent: FC<WarningIconComponentProps> = ({ type }) => {
    return (
        <AampeTooltip
            arrow
            placement="top"
            title={`Locked components need matching labels. Unlock to enable label pairing with applied learning or to pair alternates for ${type} by label.`}
        >
            <IconContainer>
                <WarningIcon />
            </IconContainer>
        </AampeTooltip>
    );
};

const WarningIcon = styled(ICONS.warning)({
    width: '24px',
    height: '24px',
    marginBottom: '-8px',
    marginLeft: '6px',
});

const IconContainer = styled.div({
    display: 'inline-block',
});
export default WarningIconComponent;
